module.exports = __webpack_public_path__ + "img/icon-level-up.2a103f7d.png";